import {Box} from "@mui/material";
import {styled} from "@mui/material/styles";
import type {SxProps, Theme} from "@mui/material";

const AnimatedChart = styled("svg")(({theme}) => ({
  maxWidth: "200px",
  maxHeight: "200px",
  "& .line": {
    stroke: theme.palette.primary.main,
    strokeWidth: 2,
    fill: "none",
    strokeDasharray: 1000,
    strokeDashoffset: 1000,
    animation: "draw 2s linear infinite",
  },
  "@keyframes draw": {
    to: {
      strokeDashoffset: 0,
    },
  },
}));

const ChartLoading = ({sx}: {sx?: SxProps<Theme>}) => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      sx={{...sx}}>
      <AnimatedChart viewBox="0 0 100 100">
        <polyline
          className="line"
          points="0,50 20,60 40,40 60,70 80,50 100,60"
        />
      </AnimatedChart>
    </Box>
  );
};

export {ChartLoading};
